import { useTranslation } from 'react-i18next';
import { BV, formatVP } from '../../../../../../helpers/helperFunctions';
import { CaptionText, H3, P1 } from '../../../../../../styles/FontStyles';
import {
  Flexed,
  SectionSeparator
} from '../../../../../../styles/GlobalComponents';
import { color } from '../../../../../../styles/GlobalStyles';

export const LegInfo = ({ legName, legInfo, todayLegTotalVolume }) => {
  const { t } = useTranslation('myTeam');
  return (
    <div>
      <P1 bold color={color.colors.neutral900}>
        {legName}
      </P1>

      <SectionSeparator margin={'12px 0'} />

      <CaptionText color={color.colors.neutral900}>
        Commissionable Volume
      </CaptionText>

      <H3 color={color.colors.neutral900}>
        {formatVP(legInfo?.legTotalVolume) ?? 0} {BV} <br />
      </H3>

      {todayLegTotalVolume >= 0 && (
        <CaptionText color={color.colors.primary900}>
          +{formatVP(todayLegTotalVolume)}{' '}
          <span
            style={{
              color: color.colors.neutral500
            }}>
            {t('today')}
          </span>
          {''}
        </CaptionText>
      )}

      <SectionSeparator margin={'12px 0'} />

      <Flexed width='100%'>
        <Flexed column width='50%'>
          <CaptionText color={color.colors.neutral900}>
            {t('total_downline')}
          </CaptionText>

          <H3 color={color.colors.neutral900}>{legInfo?.totalDownline}</H3>
        </Flexed>
        <Flexed column width='50%'>
          <CaptionText color={color.colors.neutral900}>
            {t('total_directs')}
          </CaptionText>

          <H3 color={color.colors.neutral900}>
            {legInfo?.totalDirectUsersCount}
          </H3>
        </Flexed>
      </Flexed>
      <Flexed width='100%'>
        <Flexed column width='50%'>
          <CaptionText color={color.colors.primary900}>
            +{legInfo?.todayTotalDownline}{' '}
            <span
              style={{
                color: color.colors.neutral500
              }}>
              {t('today')}
            </span>
          </CaptionText>
        </Flexed>
        <Flexed column width='50%'>
          <CaptionText color={color.colors.primary900}>
            +{legInfo?.todayTotalDirectUsersCount}{' '}
            <span
              style={{
                color: color.colors.neutral500
              }}>
              {t('today')}
            </span>
          </CaptionText>
        </Flexed>
      </Flexed>
    </div>
  );
};
